import PropTypes from 'prop-types';
import React from 'react';

/**
 * small pill showing the number of rows in a result group.
 * @param count - number to display
 * @param tone - tailwind text-color class
 * @param bg - tailwind background-color class
 */
export default function ResultCountBadge({ count, tone, bg }) {
  return (
    <span
      className={`inline-flex min-w-6 items-center justify-center rounded-full px-2 py-0.5 text-xs font-semibold ${bg} ${tone}`}
    >
      {count}
    </span>
  );
}

ResultCountBadge.propTypes = {
  count: PropTypes.number.isRequired,
  tone: PropTypes.string.isRequired,
  bg: PropTypes.string.isRequired
};
